import moment from "moment";

import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import { MyleLogo } from "@/Common/Components/MyleLogo/MyleLogo";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { LoginPage } from "@/Common/Resources/StaticResourcesFor";
import { AuthenticatorCodeValidator } from "@/Common/Validators/AuthenticatorCodeValidator";
import { LoginCredentialsView } from "./Login/LoginCredentialsView";
import { LoginPageState } from "./LoginPage";

class ReLogin extends React.Component<EmptyProps, LoginPageState> {
    private boundEventId: string;
    private resources: LoginPage;
    private stringProvider: ResourceProvider;
    private watchDogTimer: number;
    private authenticatorCodeValidator: AuthenticatorCodeValidator;

    constructor(props: EmptyProps) {
        super(props);

        this.resources = new LoginPage();
        this.stringProvider = new ResourceProvider(this.resources);
        this.authenticatorCodeValidator = new AuthenticatorCodeValidator();

        const initialState = new LoginPageState();
        sessionStore.clientLoginModel = sessionStore.clientLoginModel.set("ValidatingCredentials", false);
        initialState.model = sessionStore.clientLoginModel;

        this.state = initialState;
    }

    public componentDidMount(): void {
        this.boundEventId = sessionStore.AddChangeListener(this.StoreChangeListener, this);

        overlayStore.hideOverlay("global-overlay");

        // this will flush memory in 5 minutes if account not restred
        this.watchDogTimer = window.setTimeout(() => MyleHelper.redirectToLogin(), 60000 * 5);
    }

    public componentWillUnmount(): void {
        sessionStore.RemoveChangeListener(this.boundEventId);
        clearTimeout(this.watchDogTimer);
    }

    public render(): JSX.Element {
        const errorMessageStr = this.state.model.get("ErrorMessage");
        const showAuthenticatorCodeForm = this.state.model.get("ShowAuthenticatorCodeForm");
        const isValidAuthenticatorCode = showAuthenticatorCodeForm && this.authenticatorCodeValidator.validate(this.state.model.get("AuthenticatorCode"));
        let errorMessageJsx = null;

        if (errorMessageStr != null) {
            errorMessageJsx = (
                <div className="error-message">
                    <strong>
                        {errorMessageStr.UseLocalResource
                            ? this.stringProvider.GetString(errorMessageStr.Message)
                            : errorMessageStr.Message
                        }
                        {errorMessageStr.AccountActiveDate
                            && `${errorMessageStr.UseLocalResource ? "" : "Activation Date"}: `
                        }
                        {errorMessageStr.AccountActiveDate
                            && moment(errorMessageStr.AccountActiveDate).format("YYYY-MM-DD")
                        }
                    </strong>
                </div>
            );
        }

        const isSubmitDisabled = this.state.model.get("ValidatingCredentials")
            || (
                showAuthenticatorCodeForm
                    ? !isValidAuthenticatorCode
                    : !this.state.model.get("Password")?.length
            );

        return (
            <div className="">
                <header />
                <div className="container myle-login-page" style={{ overflowY: "hidden" }}>
                    <div className="row">
                        <div>
                            <div className="text-center" style={{ width: "500px", margin: "0 auto" }}>
                                <MyleLogo locale={sessionStore.locale} className="medfar-logo" />
                                <h3 style={{ margin: "20px 0" }}>{this.stringProvider.GetString("SessionExpiredLabel")} </h3>
                            </div>
                            <div className="login-form" style={{ width: "385px", margin: "0 auto" }}>
                                {!showAuthenticatorCodeForm && (
                                    <LoginCredentialsView
                                        userName={this.state.model.get("UserName")}
                                        validatingCredentials={this.state.model.get("ValidatingCredentials")}
                                        isLoggedIn={false}
                                        stringProvider={this.stringProvider}
                                        errorMessageJsx={errorMessageJsx}
                                        buttonTextLabelKey="RestoreLabel"
                                        linkTextLabelKey="SignInOtherAccountLabel"
                                        href="/"
                                        onUsernameChange={username => this.onUsernameChange(username)}
                                        onPasswordChange={Password => this.onPasswordChange(Password)}
                                        onSubmit={() => !isSubmitDisabled && sessionStore.dispatch(LocalOperations.Login.RestoreSession)}
                                    />
                                )}
                                {showAuthenticatorCodeForm && (
                                    <div className="row">
                                        <div className="col-lg-12 text-left">
                                            <label className="f16px" htmlFor="authenticatorCode">{this.stringProvider.GetString("AuthenticatorCodeLabel")}</label>
                                            <input
                                                type="text"
                                                id="authenticatorCode"
                                                maxLength={AuthenticatorCodeValidator.codeLength}
                                                className={`form-control ${isValidAuthenticatorCode ? "" : "invalid"}`}
                                                placeholder={this.stringProvider.GetString("AuthenticatorCodePlaceholder")}
                                                onKeyDown={e => {
                                                    if (e.key === "Enter" && !isSubmitDisabled)
                                                        sessionStore.dispatch(LocalOperations.Login.RestoreSession);
                                                }}
                                                onChange={e => this.onAuthenticatorCodeChange(e)}
                                                value={this.state.model.get("AuthenticatorCode")}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="row">
                                    <div className="col-lg-12">{errorMessageJsx}</div>
                                </div>
                                {this.state.model.get("ShowAuthenticatorCodeForm") && (
                                    <div className="row no-bottom-margin">
                                        <div className="col-lg-12">
                                            <button
                                                disabled={isSubmitDisabled}
                                                className="btn btn-primary submit"
                                                onClick={() => !isSubmitDisabled && sessionStore.dispatch(LocalOperations.Login.RestoreSession)}
                                                type="button"
                                            >
                                                {this.stringProvider.GetString("SubmitLabel")}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public onUsernameChange(username: string): void {
        sessionStore.dispatch(LocalOperations.Login.Username_TextChange, { UserName: username });
    }

    public onPasswordChange(password: string): void {
        sessionStore.dispatch(LocalOperations.Login.Password_TextChange, { Password: password });
    }

    private onAuthenticatorCodeChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const authCode = event.target.value.replace(/\D/g, "");
        sessionStore.dispatch(LocalOperations.Login.AuthenticatorCode_TextChange, { Value: authCode });
    }

    private StoreChangeListener(): void {
        const s = new LoginPageState();
        s.model = sessionStore.clientLoginModel;
        this.setState(s);
    }
}

export { ReLogin };
